export const prettyCardNumber = (cardNumber, cardTypeInfo) => {
  const card = cardTypeInfo

  if (card) {
    const offsets = [].concat(0, card.gaps, cardNumber.length)
    const components = []

    for (let i = 0; offsets[i] < cardNumber.length; i += 1) {
      const start = offsets[i]
      const end = Math.min(offsets[i + 1], cardNumber.length)
      components.push(cardNumber.substring(start, end))
    }

    return components.join(' ')
  }

  return cardNumber
}
